import {EventCustomAction, EventCustomLabel} from '_types'
import {analyticsLogEvent} from '../api'

const eventName = 'requestSize'

interface Parameters {
    action: EventCustomAction
    label: EventCustomLabel
}
/**
 * Tracks a request size event triggered by the user.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {EventCustomAction} params.action - Action of the event.
 * @param {EventCustomLabel} params.label - Label of the event.
 */
export function analyticsEventRequestSize({action, label}: Parameters) {
    // SFRA spec §6.14: uses the standard GTM keys eventCategory / eventAction / eventLabel.
    const eventDetails = {
        eventCategory: 'Request Size',
        eventAction: action,
        eventLabel: label,
    }

    analyticsLogEvent(eventName, eventDetails)
}
